import {normalize, schema, denormalize} from 'normalizr';

const invitationSchedule = new schema.Entity('invitationsSchedules', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {invitationsSchedules: [invitationSchedule]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = invitationSchedule;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = invitationSchedule;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default invitationSchedule;
